module.exports = {
      id: "pinterest-circle-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-f7c87499d4b6955c7faa356accbb279e.svg#pinterest-circle-color",
      toString: function () {
        return this.url;
      }
    }